import { Theme } from "@mui/material/styles";
import { CustomTheme } from "enums/customTheme";
import { RootState, useSelector } from "redux/store";
// ----------------------------------------------------------------------

export default function Typography(theme: Theme) {
  const customTheme = useSelector(
    (state: RootState) => state.supplier.supplier?.customTheme,
  );

  const getTextColor = () => {
    if (customTheme === CustomTheme.Volotea)
      return theme?.palette?.volotea?.brown;
    return theme?.palette?.primary?.main;
  };

  return {
    MuiTypography: {
      styleOverrides: {
        h3: {
          fontSize: "36px",
          fontWeight: 700,
          color: getTextColor(),
        },
        h6: {
          fontSize: "20px",
          fontWeight: 700,
          color: getTextColor(),
        },
        caption: {
          fontWeight: 700,
          fontSize: "12px",
          color: getTextColor(),
        },
        paragraph: {
          marginBottom: theme.spacing(2),
        },
        gutterBottom: {
          marginBottom: theme.spacing(1),
        },
      },
    },
  };
}